import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactSlider from "react-slider";
import ProductCardShop from "../component/ProductCardShop";
import { api_url } from "../helpers";
import { userContext } from "../context/UserContext";
import Pagination from "../component/Pagination";

const Shop = () => {
  const { user, setLoad, cart } = useContext(userContext);
  let [grid, setGrid] = useState(false);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(1000);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const category = useQuery().get("category");

  let [active, setActive] = useState(false);
  let sidebarController = () => {
    setActive(!active);
  };

  async function CategoriesData() {
    setLoad(true);

    const responsData = await fetch(
      api_url + "method/erp_sn.api.mega_menu.get_item_categories_with_groups",
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      }
    );

    if (responsData.ok == true) {
      const data = await responsData.json();

      if (data?.message?.length > 0) {
        const uniqueItemGroups = Array.from(
          new Set(data?.message?.flatMap((item) => item?.item_groups))
        );

        setCategories(uniqueItemGroups);
      }
    }

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  async function ProductsData() {
    setLoad(true);

    let send_data = {
      filters: {
        from_price: minPrice,
        to_price: maxPrice,
      },
    };

    if (user?.name != "guest") {
      send_data["email"] = user?.email;
    }

    if (category) {
      send_data["filters"]["item_group"] = category;
    }

    console.log(send_data);

    const response = await fetch(
      api_url + "method/erp_sn.api.related_item.get_filtered_items",
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(send_data),
        method: "POST",
      }
    );

    if (response.ok == true) {
      const data = await response.json();

      console.log(data);

      if (data?.message?.length > 0) {
        setProducts(data?.message);
      }
    }

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  useEffect(() => {
    ProductsData();
  }, [minPrice, maxPrice]);

  useEffect(() => {
    CategoriesData();
  }, []);

  return (
    <section className="shop py-80">
      <div className={`side-overlay ${active && "show"}`}></div>
      <div className="container container-lg">
        <div className="row">
          {/* Sidebar Start */}
          <div className="col-lg-3">
            <div className={`shop-sidebar ${active && "active"}`}>
              <button
                onClick={sidebarController}
                type="button"
                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
              >
                <i className="ph ph-x" />
              </button>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Product Category
                </h6>
                <ul className="max-h-540 overflow-y-auto scroll-sm">
                  {categories?.length > 0 &&
                    categories?.map((item, index) => {
                      return (
                        <li className="mb-24" key={index}>
                          <a
                            href={`/shop?category=${item}`}
                            className="text-gray-900 hover-text-main-600"
                          >
                            {item}
                          </a>
                        </li>
                      );
                    })}
                </ul>
              </div>
              <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                  Filter by Price
                </h6>
                <div className="custom--range">
                  <ReactSlider
                    className="horizontal-slider"
                    thumbClassName="example-thumb"
                    trackClassName="example-track"
                    defaultValue={[0, 1000]}
                    max={1000}
                    onChange={(e) => {
                      setMinPrice(e[0]);
                      setMaxPrice(e[1]);
                    }}
                    ariaLabel={["Lower thumb", "Upper thumb"]}
                    ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
                    renderThumb={(props, state) => {
                      const { key, ...restProps } = props;
                      return (
                        <div {...restProps} key={state.index}>
                          {state.valueNow}
                        </div>
                      );
                    }}
                    pearling
                    minDistance={100}
                  />

                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
          {/* Sidebar End */}
          {/* Content Start */}
          <div className="col-lg-9">
            {/* Top Start */}
            <div className="flex-between justify-content-end gap-16 flex-wrap mb-40 ">
              {/* <span className="text-gray-900">Showing 1-20 of 85 result</span> */}
              <div className="position-relative flex-align gap-16 flex-wrap">
                <div className="list-grid-btns flex-align gap-16">
                  <button
                    onClick={() => setGrid(true)}
                    type="button"
                    className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${
                      grid === true && "border-main-600 text-white bg-main-600"
                    }`}
                  >
                    <i className="ph-bold ph-list-dashes" />
                  </button>
                  <button
                    onClick={() => setGrid(false)}
                    type="button"
                    className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${
                      grid === false && "border-main-600 text-white bg-main-600"
                    }`}
                  >
                    <i className="ph ph-squares-four" />
                  </button>
                </div>
                <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                  <label
                    htmlFor="sorting"
                    className="text-inherit flex-shrink-0"
                  >
                    Sort by:{" "}
                  </label>
                  <select
                    defaultValue={1}
                    className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                    id="sorting"
                  >
                    <option value={1}>Popular</option>
                    <option value={1}>Latest</option>
                    <option value={1}>Trending</option>
                    <option value={1}>Matches</option>
                  </select>
                </div>
                <button
                  onClick={sidebarController}
                  type="button"
                  className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                >
                  <i className="ph-bold ph-funnel" />
                </button>
              </div>
            </div>
            {/* Top End */}
            {}
            <div className={`list-grid-wrapper ${grid && "list-view"}`}>
              {products?.length > 0 ? (
                products?.map((product, index_product) => {
                  return (
                    <ProductCardShop product={product} key={index_product} />
                  );
                })
              ) : (
                <div className="d-flex flex-column align-items-center col-lg-9 mt-24 w-100">
                  <div className="w-50 d-flex justify-content-center">
                    <img
                      src="assets/images/bg/norecordfound.png"
                      alt=""
                      className=""
                    />
                  </div>
                  <div className="mt-40">
                    <h4 className="d-flex justify-content-center">
                      There are no products in this Category!
                    </h4>
                  </div>
                </div>
              )}
            </div>
            <Pagination />
          </div>
          {/* Content End */}
        </div>
      </div>
    </section>
  );
};

export default Shop;
